<template>
  <div class="flex flex-col h-full overflow-y-auto file-uploader">
    <p>Step 1 -  Download Template</p>
    <div class="divider" />

    <div
      class="btn btn-filled inline-block mt-4"
      @click="downloadTemplate"
    >
      <div class="flex flex-row content-center">
        <div class="mr-2">
          <icon
            icon="file_generic"
            color="white"
            size="20px"
          />
        </div>
        <div class="mt-0.5">
          Download Template
        </div>
      </div>
    </div>

    <p class="mt-4">
      Step 2 - Upload Completed List
    </p>
    <div class="divider mb-2" />

    <drag-n-drop
      :key="fileKey.toString()"
      :validate="false"
      file-type="excel"
      @file-selected="handleFileSelected"
    />

    <p class="mt-4">
      Step 3 - Confirm and add to List
    </p>
    <div class="divider" />

    <div v-if="file && fileParsed">
      <div class="mt-2">
        {{ modelStore.modelName }}s to be added: <span class="font-bold">{{ tempRecords.length }}</span>
      </div>
    </div>
    <button
      v-if="file && fileParsed && tempRecords.length > 0"
      type="submit"
      class="shrink-0 w-full px-4 py-2 mt-2 rounded bg-default_primary_dark hover:bg-default_primary_darkest text-default_white cursor-pointer"
      @click="addTempRecords"
    >
      Add to list
    </button>
  </div>
</template>

<script>

import {defineComponent} from "vue";
import {useI18n} from "vue-i18n";
import DragNDrop from "@/javascript/views/clientDashboard/brand/dragNDrop.vue";
import Icon from "@/javascript/views/components/Icon.vue";

// Downloads the excel templates
// Drag & Drop to add the completed templates

export default defineComponent({
  name: "ExcelFileUploader",
  components: {Icon, DragNDrop},
  props: {
    /**
     * PROP: modelStore
     * Store passed to process the data coming from the importer
     * Needs to implement methods from this component to work
     *
     * The following methods are required in the store to work properly
     * *The component will not work without all these methods
     * @function downloadTemplate - Downloads the models template excel file
     * @function parseTemplate - Takes the filled out template file returns an array of formatted records
     * @function addToTempList - Takes one record and add it to the list of temporary records that are to be reviewed uploaded.
     **/
    modelStore: {
      type: Object,
      required: true,
    },
  },
  emits: ['add-records'],

  setup() {
    // I18n
    const {t} = useI18n();

    return {t};
  },
  data() {
    return {
      file: null,
      parsingFile: false,
      fileParsed: false,
      tempRecords: [],
      fileKey: 0 //hack to get file uploader to reset when records are cleared
    };
  },

  methods: {
    downloadTemplate() {
      this.modelStore.downloadTemplate();
    },
    async handleFileSelected(file) {
      if (!this.file) {
        this.parsingFile = true;
        this.file = file;
        this.tempRecords = await this.modelStore.parseTemplate(file);
        this.parsingFile = false;
        this.fileParsed = true;
      }
      else if(!file){
        // File was removed from the selector
        this.file = null;
        this.tempRecords = [];
        this.fileParsed = false;
      }
    },
    addTempRecords() {
      this.tempRecords.forEach(rec => {
        this.modelStore.addToTempList(rec);
      });
      this.file = null;
      this.tempRecords = [];
      this.fileParsed = false;
      this.fileKey ++;
    },
  }
});
</script>

<style lang="scss" scoped>
.divider {
  @apply bg-slate-300;
  @apply w-full;
  height: 1px;
}
.file-uploader p {
  @apply text-sm;
  @apply text-gray-600;
}
</style>
